// extracted by mini-css-extract-plugin
export default {"statsTable":"StatsTable_statsTable__fGPBI","optionsBox":"StatsTable_optionsBox__NccVC"};